export default __webpack_public_path__ + "static/media/logo-white.ca4aa9b6.png";